module.exports = __webpack_public_path__ + "static/media/pastries.848bdae2.png";